import { BaseEventProps } from "../../../types";

export enum ModuleEventProps {
  PROMO_ID = "Promo ID"
}

export enum MediatorEventType {
  OPT_IN_SUCCESSFUL = "PROMOS_OPT_IN_SUCCESSFUL",
  OPT_IN_FAILED = "PROMOS_OPT_IN_FAILED"
}

export type EventProps = BaseEventProps | ModuleEventProps;

// Payload type data
export interface PromoOptInInfo {
  type: MediatorEventType;
  payload: {
    promoId: string;
    promoName: string;
  };
}
